"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiftSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var GiftSVG = function GiftSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M4 27a3 3 0 003 3h8V19H4zM17 30h8a3 3 0 003-3v-8H17zM29 8h-4.56A3.91 3.91 0 0025 6a4 4 0 00-7-2.66 16.85 16.85 0 00-2 2.79 16.85 16.85 0 00-2-2.79A4 4 0 007 6a3.91 3.91 0 00.56 2H3a1 1 0 00-1 1v7a1 1 0 001 1h12V8h2v9h12a1 1 0 001-1V9a1 1 0 00-1-1zM11 8a2 2 0 111.49-3.34A13.16 13.16 0 0114.71 8zm8.51-3.34A2 2 0 1121 8h-3.71a13.16 13.16 0 012.22-3.34z"
  }));
};
exports.GiftSVG = GiftSVG;
GiftSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(GiftSVG);
exports.default = _default;